(() => {
  'use strict';

  if (window.__foodnetMobileHomeV78) return;
  window.__foodnetMobileHomeV78 = true;

  const TOAST_DURATION_MS = 3600;
  const TOAST_EXIT_MS = 340;
  let toastTimer = 0;

  const rootPath = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };
  const route = (path) => `${rootPath()}${String(path).replace(/^\//, '')}`;

  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  }).format((Number(cents) || 0) / 100);

  const syncHeaderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = String(cart.item_count || 0);
      count.hidden = !cart.item_count;
      count.classList.remove('fn-cart-count--updated');
      window.requestAnimationFrame(() => {
        count.classList.add('fn-cart-count--updated');
        window.setTimeout(() => count.classList.remove('fn-cart-count--updated'), 760);
      });
    });
    document.querySelectorAll('[data-header-cart-total]').forEach((total) => {
      total.textContent = formatMoney(cart.total_price);
    });
  };

  const getToast = () => {
    let toast = document.querySelector('[data-foodnet-home-toast]');
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'fn-home-toast';
    toast.hidden = true;
    toast.dataset.foodnetHomeToast = '';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    document.body.append(toast);
    return toast;
  };

  const clearToast = () => {
    const toast = getToast();
    toast.hidden = true;
    toast.dataset.state = '';
    toast.replaceChildren();
  };

  const hideToast = () => {
    const toast = getToast();
    if (toast.hidden) return;
    toast.dataset.state = 'leaving';
    toastTimer = window.setTimeout(clearToast, TOAST_EXIT_MS);
  };

  const showToast = (state, message) => {
    const toast = getToast();
    window.clearTimeout(toastTimer);
    toast.replaceChildren();

    const icon = document.createElement('span');
    icon.className = 'fn-home-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = state === 'success' ? '✓' : '!';

    const copy = document.createElement('span');
    copy.className = 'fn-home-toast__copy';
    const title = document.createElement('strong');
    title.className = 'fn-home-toast__title';
    title.textContent = state === 'success' ? 'Toegevoegd' : 'Toevoegen mislukt';
    const detail = document.createElement('span');
    detail.className = 'fn-home-toast__detail';
    detail.textContent = state === 'success' ? 'Het product staat in je winkelwagen.' : message;
    const progress = document.createElement('span');
    progress.className = 'fn-home-toast__progress';
    progress.setAttribute('aria-hidden', 'true');

    copy.append(title, detail);
    toast.append(icon, copy, progress);
    toast.style.setProperty('--fn-home-toast-duration', `${TOAST_DURATION_MS}ms`);
    toast.hidden = false;
    toast.dataset.state = state;
    toastTimer = window.setTimeout(hideToast, state === 'success' ? TOAST_DURATION_MS : 5000);
  };

  const initRevealMotion = () => {
    const targets = Array.from(document.querySelectorAll([
      '.w65-intro__surface',
      '.wk-home-categories__head',
      '.wk-home-categories__grid',
      '.w81nr__head',
      '.w81nr__shell',
      '.promo-banner',
      '.wk-brands__header',
      '.wk-brands__viewport',
      '.w92-usp__grid'
    ].join(',')));

    if (!targets.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    document.body.classList.add('fn-home-motion-ready');
    targets.forEach((target) => target.classList.add('fn-home-reveal-target'));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    targets.forEach((target) => observer.observe(target));
  };

  const initBrandAutoplay = (scope = document) => {
    const roots = [];
    if (scope instanceof Element && scope.matches('[id^="WokoraHomeBrands-"]')) roots.push(scope);
    scope.querySelectorAll?.('[id^="WokoraHomeBrands-"]').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      if (root.dataset.fnBrandAutoplay === 'transform-v2') return;
      const viewport = root.querySelector('.wk-brands__viewport');
      const track = root.querySelector('.wk-brands__track');
      const groups = track ? Array.from(track.querySelectorAll('.wk-brands__group')) : [];
      if (!viewport || !track || groups.length < 2) return;

      root.dataset.fnBrandAutoplay = 'transform-v2';
      viewport.style.setProperty('overflow', 'hidden', 'important');
      viewport.style.setProperty('scroll-snap-type', 'none', 'important');
      viewport.style.setProperty('scrollbar-width', 'none', 'important');
      viewport.style.setProperty('-ms-overflow-style', 'none', 'important');
      viewport.scrollLeft = 0;

      track.style.setProperty('display', 'flex', 'important');
      track.style.setProperty('width', 'max-content', 'important');
      track.style.setProperty('min-width', 'max-content', 'important');
      track.style.setProperty('animation', 'none', 'important');
      track.style.setProperty('-webkit-animation', 'none', 'important');
      track.style.setProperty('will-change', 'transform', 'important');

      groups.forEach((group, index) => {
        group.style.setProperty('display', 'flex', 'important');
        group.style.setProperty('flex', '0 0 auto', 'important');
        if (index > 0) {
          group.setAttribute('aria-hidden', 'true');
          group.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
        }
      });

      let loopWidth = 0;
      let offset = 0;
      let lastTime = 0;
      let visible = true;
      let pointerDown = false;
      let pauseUntil = 0;
      const durationSeconds = Math.max(18, parseFloat(getComputedStyle(root).getPropertyValue('--wk-brands-duration')) || 52);

      const measure = () => {
        const measured = groups[1].offsetLeft - groups[0].offsetLeft;
        loopWidth = Math.max(1, measured || groups[0].getBoundingClientRect().width);
        offset %= loopWidth;
      };

      const pauseFor = (ms) => {
        pauseUntil = Math.max(pauseUntil, performance.now() + ms);
      };

      viewport.addEventListener('pointerdown', () => { pointerDown = true; }, { passive: true });
      const releasePointer = () => {
        if (!pointerDown) return;
        pointerDown = false;
        pauseFor(700);
        lastTime = performance.now();
      };
      window.addEventListener('pointerup', releasePointer, { passive: true });
      window.addEventListener('pointercancel', releasePointer, { passive: true });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(measure);
        resizeObserver.observe(viewport);
        resizeObserver.observe(groups[0]);
      } else {
        window.addEventListener('resize', measure, { passive: true });
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          visible = entries.some((entry) => entry.isIntersecting);
          lastTime = performance.now();
        }, { rootMargin: '240px 0px', threshold: 0 });
        observer.observe(root);
      }

      document.addEventListener('visibilitychange', () => { lastTime = performance.now(); });

      const frame = (time) => {
        if (!lastTime) lastTime = time;
        const delta = Math.min(64, Math.max(0, time - lastTime));
        lastTime = time;
        if (visible && !document.hidden && !pointerDown && time >= pauseUntil && loopWidth > 1) {
          offset += (loopWidth / (durationSeconds * 1000)) * delta;
          if (offset >= loopWidth) offset %= loopWidth;
        }
        track.style.setProperty('transform', `translate3d(${-offset}px,0,0)`, 'important');
        window.requestAnimationFrame(frame);
      };

      measure();
      window.requestAnimationFrame(() => {
        measure();
        window.requestAnimationFrame(frame);
      });
    });
  };

  const handleQuickAdd = async (event) => {
    const form = event.target.closest?.('form.w81nr__action');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (form.dataset.foodnetBusy === 'true') return;

    const button = form.querySelector('button[type="submit"]');
    form.dataset.foodnetBusy = 'true';
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
    }

    try {
      const response = await fetch(route('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || 'Dit product kon niet worden toegevoegd.');

      const cartResponse = await fetch(route('cart.js'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        syncHeaderCart(cart);
        document.dispatchEvent(new CustomEvent('wokora:cart-updated', { detail: { cart } }));
      }
      showToast('success', 'Toegevoegd aan je winkelwagen.');
    } catch (error) {
      showToast('error', error?.message || 'Probeer opnieuw.');
    } finally {
      form.dataset.foodnetBusy = 'false';
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      }
    }
  };

  const boot = () => {
    initRevealMotion();
    initBrandAutoplay();
    document.addEventListener('submit', handleQuickAdd, true);
    document.addEventListener('shopify:section:load', (event) => initBrandAutoplay(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
